import _toConsumableArray from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { array } from 'vega-util';
import { isQuantitative } from '../../scale';
import { keys, titleCase } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { getStyleConfig, signalOrStringValue } from '../common';

function getAxisConfigFromConfigTypes(configTypes, config, channel, orient) {
  // TODO: add special casing to add conditional value based on orient signal
  return Object.assign.apply(null, [{}].concat(_toConsumableArray(configTypes.map(function (configType) {
    if (configType === 'axisOrient') {
      var orient1 = channel === 'x' ? 'bottom' : 'left';
      var orientConfig1 = config[channel === 'x' ? 'axisBottom' : 'axisLeft'] || {};
      var orientConfig2 = config[channel === 'x' ? 'axisTop' : 'axisRight'] || {};
      var props = new Set([].concat(_toConsumableArray(keys(orientConfig1)), _toConsumableArray(keys(orientConfig2))));
      var conditionalOrientAxisConfig = {};

      var _iterator = _createForOfIteratorHelper(props.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var prop = _step.value;
          conditionalOrientAxisConfig[prop] = {
            // orient is surely signal in this case
            signal: "".concat(orient['signal'], " === \"").concat(orient1, "\" ? ").concat(signalOrStringValue(orientConfig1[prop]), " : ").concat(signalOrStringValue(orientConfig2[prop]))
          };
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return conditionalOrientAxisConfig;
    }

    return config[configType];
  }))));
}

export function getAxisConfigs(channel, scaleType, orient, config) {
  var typeBasedConfigTypes = scaleType === 'band' ? ['axisDiscrete', 'axisBand'] : scaleType === 'point' ? ['axisDiscrete', 'axisPoint'] : isQuantitative(scaleType) ? ['axisQuantitative'] : scaleType === 'time' || scaleType === 'utc' ? ['axisTemporal'] : [];
  var axisChannel = channel === 'x' ? 'axisX' : 'axisY';
  var axisOrient = isSignalRef(orient) ? 'axisOrient' : "axis".concat(titleCase(orient)); // axisTop, axisBottom, ...

  var vlOnlyConfigTypes = [].concat(typeBasedConfigTypes, _toConsumableArray(typeBasedConfigTypes.map(function (c) {
    return axisChannel + c.substr(4);
  })));
  var vgConfigTypes = ['axis', axisOrient, axisChannel];
  return {
    vlOnlyAxisConfig: getAxisConfigFromConfigTypes(vlOnlyConfigTypes, config, channel, orient),
    vgAxisConfig: getAxisConfigFromConfigTypes(vgConfigTypes, config, channel, orient),
    axisConfigStyle: getAxisConfigStyle([].concat(vgConfigTypes, _toConsumableArray(vlOnlyConfigTypes)), config)
  };
}
export function getAxisConfigStyle(axisConfigTypes, config) {
  var _a;

  var toMerge = [{}];

  var _iterator2 = _createForOfIteratorHelper(axisConfigTypes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var configType = _step2.value;
      // TODO: add special casing to add conditional value based on orient signal
      var style = (_a = config[configType]) === null || _a === void 0 ? void 0 : _a.style;

      if (style) {
        style = array(style);

        var _iterator3 = _createForOfIteratorHelper(style),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var s = _step3.value;
            toMerge.push(config.style[s]);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return Object.assign.apply(null, toMerge);
}
export function getAxisConfig(property, styleConfigIndex, style) {
  var axisConfigs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _a;

  var styleConfig = getStyleConfig(property, style, styleConfigIndex);

  if (styleConfig !== undefined) {
    return {
      configFrom: 'style',
      configValue: styleConfig
    };
  }

  for (var _i = 0, _arr = ['vlOnlyAxisConfig', 'vgAxisConfig', 'axisConfigStyle']; _i < _arr.length; _i++) {
    var configFrom = _arr[_i];

    if (((_a = axisConfigs[configFrom]) === null || _a === void 0 ? void 0 : _a[property]) !== undefined) {
      return {
        configFrom: configFrom,
        configValue: axisConfigs[configFrom][property]
      };
    }
  }

  return {};
}